import React from "react";
import DataTable from "react-data-table-component";
import "./DataTable.css";


const TableComponent = ({ customStyles, columns, data, totalRows, handlePageChange, handlePerRowsChange, isPagination, resetPagination, isPerPageHide, paginationPerPage, isHeader, selectableRows, onRowClicked, conditionalRowStyles }) => {

    const customStylesData = customStyles || {
        rows: {
            style: {
                minHeight: '40px', whiteSpace: 'normal', textAlign: "center"
            },
        },
        headCells: {
            style: {
                fontSize: '13px', fontWeight: '600', paddingLeft: '0px', paddingRight: '0px', color: 'var(--black)', whiteSpace: 'normal', textAlign: "center"
            },
        },
        cells: {
            style: {
                fontSize: '12px', paddingLeft: '0px', paddingRight: '0px', paddingTop: '3px', paddingBottom: '3px', color: 'var(--black)', whiteSpace: 'normal', textAlign: "center"
            },
        },
        footCells: { style: { textAlign: "center", color: 'var(--black)' } }
    };

    const paginationComponentOptions = {
        noRowsPerPage: isPerPageHide,
    };

    return (<>
        <div className="tableMain">
            <DataTable
                selectableRows={selectableRows || null}
                onRowClicked={(row) => onRowClicked?.(row)}
                conditionalRowStyles={conditionalRowStyles || []}
                data={data}
                noTableHead={!isHeader ?? true}
                columns={columns}
                pagination={isPagination ?? true}
                paginationServer
                paginationPerPage={paginationPerPage}
                paginationTotalRows={totalRows}
                paginationResetDefaultPage={resetPagination}
                paginationDefaultPage={1}
                onChangePage={(page, totalRows) => handlePageChange(page)}
                onChangeRowsPerPage={(newPerPage, page) => handlePerRowsChange(newPerPage, page)}
                customStyles={customStylesData}
                paginationComponentOptions={paginationComponentOptions}
                noDataComponent={<div className="table-no-data-found">There are no data to display.</div>}
            />
        </div>
    </>);
};

export default TableComponent;